var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3252",
  "data-name": "Group 3252",
  transform: "translate(-16 -480)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2298",
  "data-name": "Rectangle 2298",
  width: 16,
  height: 16,
  transform: "translate(16 480)",
  fill: "#afb6c0",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3244",
  "data-name": "Group 3244"
}, /*#__PURE__*/React.createElement("g", {
  id: "Union_1",
  "data-name": "Union 1",
  transform: "translate(15 480)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.3,14.443l0,0-2.034.882a.5.5,0,0,1-.651-.673l.928-1.949q-.1-.125-.191-.255A7.725,7.725,0,0,1,1,8a8,8,0,1,1,8,8A7.8,7.8,0,0,1,4.3,14.443Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 9.000000953674316 15.00020027160645 C 12.85987091064453 15.00020027160645 16.00010108947754 11.85997009277344 16.00010108947754 8.000100135803223 C 16.00010108947754 4.140230178833008 12.85987091064453 1.00000011920929 9.000000953674316 1.00000011920929 C 5.140130996704102 1.00000011920929 1.999900937080383 4.140230178833008 1.999900937080383 8.000100135803223 C 1.999900937080383 9.429790496826172 2.432330846786499 10.87182998657227 3.156641006469727 11.85756969451904 L 3.160490989685059 11.8628396987915 C 3.21648097038269 11.94009017944336 3.274430990219116 12.01741981506348 3.332720994949341 12.09269046783447 L 3.709521055221558 12.57917022705078 L 3.090837001800537 13.87905025482178 L 3.899160861968994 13.52849006652832 L 4.431540966033936 13.29258060455322 L 4.899470806121826 13.63916969299316 C 6.101611137390137 14.52956008911133 7.519550800323486 15.00020027160645 9.000000953674316 15.00020027160645 M 9.000000953674316 16.00020027160645 C 7.267530918121338 16.00020027160645 5.663421154022217 15.44943046569824 4.304280757904053 14.44274997711182 C 4.302610874176025 14.44349002838135 4.300981044769287 14.44427013397217 4.299301147460938 14.44499969482422 L 2.265300989151001 15.32699966430664 C 1.841399431228638 15.51060485839844 1.416601061820984 15.07050037384033 1.614600896835327 14.65380001068115 L 2.542130947113037 12.70503044128418 C 2.477340936660767 12.62137985229492 2.413480997085571 12.53618049621582 2.35080099105835 12.44970035552979 C 1.567800998687744 11.38409996032715 0.9999009370803833 9.758700370788574 0.9999009370803833 8.000100135803223 C 0.9999009370803833 3.582000017166138 4.581901073455811 1.358032193365943e-07 9.000000953674316 1.358032193365943e-07 C 13.41810131072998 1.358032193365943e-07 17.00010108947754 3.582000017166138 17.00010108947754 8.000100135803223 C 17.00010108947754 12.41820049285889 13.41810131072998 16.00020027160645 9.000000953674316 16.00020027160645 Z",
  stroke: "none",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "exclamation-mark",
  transform: "translate(-187.6 484)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_100",
  "data-name": "Path 100",
  d: "M211.7,422a.737.737,0,1,0,.7.736A.719.719,0,0,0,211.7,422Z",
  transform: "translate(0 -415.472)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  d: "M211.7,0a.7.7,0,0,0-.7.693V5.3a.7.7,0,0,0,1.4,0V.693A.7.7,0,0,0,211.7,0Z",
  fill: "#fff"
}))))));
export default __webpack_public_path__ + "static/media/req.af87abe1.svg";
export { SvgComponent as ReactComponent };